const cookies = (() => {
    let cookies;

    const init = () => {
        cookies = document.querySelector("[data-cookies-bar]");
        if (!cookies) return;

        if(!getCookie("cookies")) cookies.style.display = "block";

        cookies.querySelectorAll("[data-cookies-close]").forEach(each => (each.onclick = closeCookies));
    };

    const closeCookies = (e) => {
        e.preventDefault();
        cookies.classList.add("closed");
        const animationEnd = () => {
            cookies.style.display = "none";
            cookies.setAttribute("aria-hidden", "true");
        };
        cookies.addEventListener('transitionend', animationEnd, false);
        cookies.addEventListener('webkitTransitionEnd', animationEnd, false);
        createCookie("cookies", "accepted", 30);
    };

    const getCookie = (name) => {
        const value = "; " + document.cookie;
        const parts = value.split("; " + name + "=");
        if (parts.length === 2) return parts.pop().split(";").shift();
    };

    const createCookie = (name, value, days) => {
        let expires;
        if (days) {
            let date = new Date();
            date.setTime(date.getTime()+(days*24*60*60*1000));
            expires = "; expires="+date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name+"="+value+expires+"; path=/";
    };

    return {
        init: init
    };
})();

export {cookies}